
import { useState, useEffect } from "react"
import { Button } from "@/components/ui/button"
import { Sheet, SheetTrigger } from "@/components/ui/sheet"
import { Bell } from "lucide-react"
import { NotificationPanel } from "@/components/notification-panel"
import { fetchUnreadCount } from "@/lib/services/notifications"
import { useAuth } from "@/lib/auth/auth-context"

export function NotificationBell() {
  const { user } = useAuth()
  const [unreadCount, setUnreadCount] = useState(0)
  const [open, setOpen] = useState(false)

  // Load initial unread count
  useEffect(() => {
    if (!user?.id) {
      setUnreadCount(0)
      return
    }

    const loadUnreadCount = async () => {
      try {
        const count = await fetchUnreadCount(user.id)
        setUnreadCount(count)
      } catch (error) {
        console.error('Error loading unread count:', error)
      }
    }

    loadUnreadCount()
  }, [user?.id])

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="relative">
          <Bell className="h-5 w-5" />
          {unreadCount > 0 && (
            <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-destructive text-destructive-foreground text-xs font-bold flex items-center justify-center">
              {unreadCount > 99 ? '99+' : unreadCount}
            </span>
          )}
        </Button>
      </SheetTrigger>
      <NotificationPanel onUnreadCountChange={setUnreadCount} />
    </Sheet>
  )
}
